import { ArrowRightOutlined } from '@ant-design/icons';
import { Col, Row } from 'antd';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { getSupplyZoneEffect } from '../../../redux/Savers/SaversEffects';
import ScrollPagination from '../../components/Paginations/ScrollPagination';
import SupplyZoneSearch from '../../screens/Savers/SupplyZoneSearch';
import '../../../styles/savers/custom.css';
import { exportSaversDataToExcel } from '@/utils/excel';
import { setLocationRequestId } from '../../../redux/Savers/SaversActions';
import { setAppLoader } from '../../../redux/common/CommonActions';
import SecondaryLabel from '../../components/Labels/SecondaryLabel';

export default function SupplyZone() {
  const [hasMore, setHasMore] = useState(true);
  const [supplyZoneOptions, setSupplyZoneOptions] = useState([]);
  const [errMessage, setErrMessage] = useState('');
  const { selectedCompany } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userRole = useSelector((state) => state.savers.loggedInUser.data);

  useEffect(() => {
    getSupplyZones();
  }, [selectedCompany]);

  const getSupplyZones = async () => {
    dispatch(setAppLoader(true));
    try {
      const { data } = await getSupplyZoneEffect();
      setSupplyZoneOptions((prevOptions) => [...prevOptions, ...data]);
      setHasMore(data.length > 0);
      if (data.length === 0) {
        setErrMessage('Data not found.');
      } else {
        setErrMessage('');
      }
    } catch (error) {
      console.error('Error fetching supply zones:', error);
    } finally {
      dispatch(setAppLoader(false));
    }
  };

  const columnFormatter = () => {
    return <ArrowRightOutlined />;
  };

  const inactiveFormatter = (cell) => {
    return <span>{cell?.trim().toLowerCase() === 'active' ? 'N' : 'Y'} </span>;
  };

  const columns = [
    { dataField: 'branchKey', text: 'Id', align: 'right', hidden: true },
    { dataField: 'branchCustRef', text: 'Supply Zone Number', align: 'left' },
    { dataField: 'branchDesc', text: 'Supply Zone Name', align: 'left' },
    { dataField: 'regionDesc', text: 'Region Name', align: 'left' },
    {
      dataField: 'status',
      text: 'Inactive',
      formatter: inactiveFormatter,
      align: 'left',
    },
    {
      dataField: 'branchKey',
      text: 'Go to Trailer List per SZ',
      align: 'center',
      hidden: true,
      formatter: columnFormatter,
      events: {
        onClick: (_e, _column, _columnIndex, row) => {
          LoadTrailerData(row.branchKey);
        },
      },
    },
  ];

  const LoadTrailerData = (branchKey) => {
    dispatch(setLocationRequestId(branchKey));
    navigate('/Trailer-Database');
  };

  const handleExport = () => {
    const filteredColumns = columns.filter((column) => column.dataField !== 'branchKey');

    exportSaversDataToExcel(supplyZoneOptions, 'Supply_Zone_Data', filteredColumns);
  };

  return (
    <>
      <Row gutter={20}>
        <Col sm={24}>
          <span className="pull-right color-1" style={{ position: 'fixed', right: '32px', marginTop: '-26px' }}>
            {' '}
            <strong> {userRole} </strong> Logged In{' '}
          </span>
        </Col>
      </Row>
      <div className="paper-container h-100 w-100">
        <div className="py-5 px-10">
          <Row gutter={15}>
            <Col sm={24}>
              <div className="savers savers-supply-zone">
                <Row justify="space-between" className="mb-4">
                  <Col>
                    <SupplyZoneSearch onSearchClick={getSupplyZones} />
                  </Col>

                  <Col>
                    <button className="btn btn-dipblue" type="button" onClick={handleExport}>
                      Export to Excel
                    </button>
                  </Col>
                </Row>

                <ScrollPagination
                  className="background-white br-4 w-100 h-100 scrollable-table-container horizontal"
                  loadMore={getSupplyZones}
                  hasMore={hasMore}
                  scrollOffset={50}
                  hideSpinner={false}
                >
                  <table className="w-100 background-white br-4">
                    <thead className=" ">
                      <tr>
                        {columns.map(
                          ({ text, hidden }) =>
                            !hidden && (
                              <th key={text} className="background-header text-white fixed fixed-top fixed-left">
                                {text}
                              </th>
                            ),
                        )}
                      </tr>
                    </thead>
                    <tbody>
                      {supplyZoneOptions.length === 0 ? (
                        <tr>
                          <td colSpan={columns.length} style={{ textAlign: 'center', color: 'red' }}>
                            {errMessage}
                          </td>
                        </tr>
                      ) : (
                        supplyZoneOptions.map((row, index) => (
                          <tr key={`${row.branchKey}-${index}`}>
                            <GenerateColumnValues row={row} columns={columns} />
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </ScrollPagination>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
}

const GenerateColumnValues = ({ row, columns }) => {
  return (
    <>
      {columns.map(
        ({ dataField, formatter, hidden, align, events }) =>
          !hidden && (
            <td key={dataField} className={`text-${align || 'left'}`}>
              <SecondaryLabel className="f-15 fw-600 text-black">
                {events?.onClick ? (
                  <Link to="#" onClick={(e) => events.onClick(e, null, null, row, null)}>
                    {formatter ? formatter(row[dataField], row) : row[dataField]}
                  </Link>
                ) : formatter ? (
                  formatter(row[dataField], row)
                ) : (
                  row[dataField]
                )}
              </SecondaryLabel>
            </td>
          ),
      )}
    </>
  );
};
